import React, { Component } from 'react';
import { ButtonPrimary, LoadOptions } from 'ui';
import * as navigate from 'app/area/shared/navigation';
import { CodeCategory } from 'app/area/codetable/list/search/code-category';
import { NumberOfResults } from 'app/area/codetable/list/search';
import { SpinLoader } from 'app/components';
import { CodetableListItems } from 'app/area/codetable/list/list-items';
import { routeConstants } from 'app/routes/route-constants';
import { AddCodeModal } from 'app/area/codetable/list/list-items/add-code-modal';
import { substanceCodetableIds } from 'app/area/codetable/item/constants';
import { codeFieldIncludeInactive } from 'app/area/codetable/common/codetable-options-handler/constants';
import { CodetableListComponentProps } from 'app/area/codetable/list/list-items/types';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { addLinkFactory } from 'app/area/codetable/list/list-renderer/common/add-link-factory';
import { MergeCodeContainer } from 'app/area/codetable/common/merge-code/merge-code-container';
import styles from './uom-set-codetable-list-component.scss';

export class UomSetCodetableListComponent extends Component<CodetableListComponentProps> {
  private handleClickAddButton = (codeId: number) => {
    navigate.replace(routeConstants.codetableAdministrationDuplicateCodeFor(this.props.breadcrumbs, codeId));
    return;
  };

  private loadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    this.props.loadCodetableOptions(id,
      substanceCodetableIds.uomSets, {
      ...loadOptionsParams,
      includeNotSelected: true,
      includeInactiveCodes: codeFieldIncludeInactive.all
    });
  };

  public render() {
    const { category, codetableOptions, isHierarchy, isHierarchyMode, shouldRenderList,
      shouldRenderSpinLoader, updateCategory, loadCodetableOptions, hasCategoryMetadata, hasSelectedCategory,
      breadcrumbs, codetableId, codeId, codeListBranch, rootBranch, codeAccessConfiguration,
      codeListBranchState, loadFromParent, reloadCodeItems, expandCodeItem, deleteCodeItem,
      listCategoryLabel, loadCodesAccess, clearCodesAccess,
      metadata, mergeCode, updateMergeCode, updateConfirmPrompt, options, loadOptions, validation, resetValidation,
      codeAccessConfiguration: { canCreate } = {},
      itemAccess, fetchingItemAccess, translation } = this.props;

    const rightToolbar = canCreate && <AddCodeModal
      id={'codetable-list-link-create-modal'}
      buttonText={translation.add_new}
      labelText={translation.uom_sets_add_label}
      dropdownLabelText={translation.uom_sets_add_dropdown_label}
      submitText={translation.done}
      submit={this.handleClickAddButton}
      pickerId="uomSets"
      codes={codetableOptions?.uomSets?.codes ?? []}
      fetching={codetableOptions?.uomSets?.fetching ?? false}
      loadOptions={this.loadOptions}
      ButtonComponent={ButtonPrimary}
      translation={translation}
    />;

    return <SearchFilters
      {...this.props}
      rightToolbar={rightToolbar}>
      <div className={`${styles.codetableListContainer} ${styles.codetableListCenter}`}>
        <div className={styles.codetableListHolder}>
          <CodeCategory
            breadcrumbs={breadcrumbs}
            category={category}
            metadata={metadata}
            options={codetableOptions}
            loadOptions={loadCodetableOptions}
            onChange={updateCategory}
            translation={translation}
            listCategoryLabel={listCategoryLabel}
          />
          <div className={styles.numberOfResults}>
            {(!hasCategoryMetadata || (hasCategoryMetadata && hasSelectedCategory))
              && <NumberOfResults
                rootBranch={rootBranch}
                translation={this.props.translation} />}
          </div>

          {shouldRenderSpinLoader ? <SpinLoader /> : undefined}
          {
            shouldRenderList && <div className={`${styles.listItemsContainer} ${isHierarchyMode ? styles.hierarchyResults : ''}`}>

              <div className={styles.listItems}>
                <CodetableListItems
                  itemAccess={itemAccess}
                  fetchingItemAccess={fetchingItemAccess}
                  breadcrumbs={breadcrumbs}
                  treeDepthLevel={0}
                  hierarchyMetadata={[]}
                  isZebra={undefined}
                  codetableId={codetableId}
                  codeId={codeId}
                  isHierarchyMode={isHierarchyMode}
                  isHierarchy={isHierarchy}
                  codeAccessConfiguration={codeAccessConfiguration}
                  codeListBranchState={codeListBranchState}
                  codeListBranch={codeListBranch}
                  loadFromParent={loadFromParent}
                  reloadCodeItems={reloadCodeItems}
                  expandCodeItem={expandCodeItem}
                  deleteCodeItem={deleteCodeItem}
                  loadCodesAccess={loadCodesAccess}
                  clearCodesAccess={clearCodesAccess}
                  parentId={undefined}
                  translation={translation}
                  addLinkFactory={addLinkFactory}
                  validation={validation}
                  resetValidation={resetValidation}
                  metadata={metadata}
                  mergeCode={mergeCode}
                  updateMergeCode={updateMergeCode}
                  updateConfirmPrompt={updateConfirmPrompt}
                  options={options}
                  loadOptions={loadOptions} />
              </div>
            </div>
          }
          {hasCategoryMetadata && !hasSelectedCategory && <p className="no-content">{translation.no_category}</p>}
        </div>
      </div>
      <MergeCodeContainer {...this.props} />
    </SearchFilters>;
  }
}
